function p(e) {
  return typeof e == "string" || e instanceof String;
}
function E(e) {
  var t;
  return typeof e == "object" && e != null && (e == null || (t = e.constructor) == null ? void 0 : t.name) === "Object";
}
function a(e, t) {
  return Array.isArray(t) ? a(e, (n, i) => t.includes(i)) : Object.entries(e).reduce((n, i) => {
    let [r, f] = i;
    return t(f, r) && (n[r] = f), n;
  }, {});
}
const o = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function R(e) {
  switch (e) {
    case o.LEFT:
      return o.FORCE_LEFT;
    case o.RIGHT:
      return o.FORCE_RIGHT;
    default:
      return e;
  }
}
function O(e) {
  return e.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function g(e, t) {
  if (t === e)
    return !0;
  const n = Array.isArray(t), i = Array.isArray(e);
  let r;
  if (n && i) {
    if (t.length != e.length)
      return !1;
    for (r = 0; r < t.length; r++)
      if (!g(t[r], e[r]))
        return !1;
    return !0;
  }
  if (n != i)
    return !1;
  if (t && e && typeof t == "object" && typeof e == "object") {
    const f = t instanceof Date, c = e instanceof Date;
    if (f && c)
      return t.getTime() == e.getTime();
    if (f != c)
      return !1;
    const s = t instanceof RegExp, l = e instanceof RegExp;
    if (s && l)
      return t.toString() == e.toString();
    if (s != l)
      return !1;
    const u = Object.keys(t);
    for (r = 0; r < u.length; r++)
      if (!Object.prototype.hasOwnProperty.call(e, u[r]))
        return !1;
    for (r = 0; r < u.length; r++)
      if (!g(e[u[r]], t[u[r]]))
        return !1;
    return !0;
  } else if (t && e && typeof t == "function" && typeof e == "function")
    return t.toString() === e.toString();
  return !1;
}
export {
  o as DIRECTION,
  O as escapeRegExp,
  R as forceDirection,
  E as isObject,
  p as isString,
  g as objectIncludes,
  a as pick
};
